import { StoreSubscription, Subscription } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { queryKeys } from '../util/query-keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

interface MembershipHookResult {
  isLoading: boolean
  subscriptions: Subscription[]
  storeSubscription: StoreSubscription | undefined
  hasSubscription: boolean
}

export const useMembership = (): MembershipHookResult => {
  const { data: storeSubscription, isLoading: isLoadingStoreSubscription } = useQuery<StoreSubscription | undefined, Error>(
    queryKeys.mySubscriptions(),
    () => coreService.getMySubscriptions(),
    {
      keepPreviousData: true,
    },
  )

  const { data: subscriptions = [], isLoading: isLoadingDetailedSubscriptions } = useQuery<Subscription[], Error>(
    queryKeys.detailedSubscriptions(),
    () => coreService.getDetailedSubscriptions(),
    {
      keepPreviousData: true,
    },
  )

  const hasSubscription = useMemo(
    (): boolean => subscriptions.length > 0 || storeSubscription?.store === 'stripe',
    [subscriptions, storeSubscription],
  )

  const isLoading = isLoadingStoreSubscription || isLoadingDetailedSubscriptions

  return {
    isLoading,
    subscriptions,
    storeSubscription,
    hasSubscription,
  }
}
